/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EbsTarget } from '../models/EbsTarget';

export class EbsRestoreDestination {
  'awsEbs'?: EbsTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEbs",
      "baseName": "awsEbs",
      "type": "EbsTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EbsRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

